<template>
  <div>
    <h3>미션달성형 > 캠페인 상세 (조회)</h3>
    <b-card header="캠페인 상세보기">
      <b-form class="mt-3"
              @submit.prevent="onSubmit">
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="광고주명">
          <b-form-input v-model="mission.advertiserName" disabled>

          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="게임명">
          <b-form-input v-model="mission.gameName" disabled>

          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="캠페인명"
                      description="* 마이다스 어드민에 등록된 캠페인명으로 기재해 주세요.">
          <b-form-input v-model="mission.name" disabled>

          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="코드 이름"
                      description="* 게임에서 이모티콘 지급 요청 URL 호출 시 포함되는 code-name 입니다. URL 포맷 : https://game.kakao.com/code-names/{code-name}/users/{user-id}
                        <br>* 영소문자, 숫자만 입력해주세요.">
          <b-form-input v-model="mission.codeName" disabled>

          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="집행기간"
                      description="* 마이다스 어드민에 등록된 집행기간과 동일하게 설정해 주세요. API 연동테스트는 시작일 기준 30일 전부터 가능합니다.">
          <b-row>
            <b-col>
              <date-picker v-model="mission.startAt" :config="dateOptions" disabled>

              </date-picker>
            </b-col>
            <b-col class="col-auto col-form-label">~</b-col>
            <b-col>
              <date-picker v-model="mission.endAt" :config="dateOptions" disabled>

              </date-picker>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="이모티콘 api key"
                      description="* 브랜드 이모티콘 지원 요청이 완료되면, 카카오에서 발급해주는 키값입니다.">
          <b-input-group>
            <b-form-input v-model="mission.extraInfo.kakaoRewardApiKey" disabled>

            </b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="총 구매금액"
                      description="* 마이다스 어드민에 등록된 금액으로 설정해 주세요.">
          <money class="form-control"
                 v-model="mission.totalPurchaseAmount"
                 disabled="disabled"
                 v-bind="won">
          </money>
        </b-form-group>

        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="이모티콘 단가"
                      description="* 마이다스 어드민에 등록된 금액으로 설정해 주세요.">
          <money class="form-control"
                 v-model="mission.rewardUnitPrice"
                 disabled="disabled"
                 v-bind="won">
          </money>
        </b-form-group>

        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="고객센터 문구"
                      description="* 이모티콘 지급 요청 페이지의 주의사항에 노출되는 게임사의 고객센터 정보입니다.">
          <b-form-input v-model="mission.customerSupportName" disabled>

          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="고객센터 링크"
                      description="* 게임사 고객센터로 접속할 수 있는 링크가 있는 경우에만 설정하세요.<br>
                                   * 이메일 주소로 링크를 설정하는 경우에는 mailto:이메일주소 포맷으로 설정해주세요.">
          <b-form-input v-model="mission.customerSupportUrl" disabled>

          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="아지트 링크"
                      description="* 브랜드 이모티콘 지원 요청한 아지트 링크를 기재해 주세요.">
          <b-form-input v-model="mission.agitUrl" disabled>

          </b-form-input>
        </b-form-group>
        <b-form-group label-cols="1" horizontal label-class="text-right"
                      label="미션 정의"
                      description="* 게임에 적용된 이모티콘 지급 조건을 기재해 주세요.">
          <b-form-input v-model="mission.missionDescription" disabled>

          </b-form-input>
        </b-form-group>
        <div class="text-center">
          <b-button class="mr-3" @click="toList">
            뒤로가기
          </b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
  import DatePicker from "vue-bootstrap-datetimepicker/src/component";
  import adMasterApi from "@/common/gap/api/adMasterApi.js";
  import missionApi from "@/common/gap/api/missionApi.js";
  import gapmoment from "@/common/gap/util/gapmoment";
  import Mission from "@/common/gap/model/mission";

  import {Money} from "v-money";

  export default {
    components: {DatePicker, Money},
    data() {
      return {
        won: {precision: 0, suffix: ' 원'},
        dateOptions: {
          format: 'YYYY-MM-DD HH:mm:ss',
          useCurrent: true
        },
        mission: new Mission(),
      }
    },
    mounted() {
      missionApi.getMission(this.viewingMissionId).then(
          getMissionResponse => { //미션 찾아서 넣기
            if (getMissionResponse.data &&
                getMissionResponse.data.data &&
                getMissionResponse.data.data.mission) {
              this.mission = new Mission(getMissionResponse.data.data.mission);

            } else {
              alert(`잘못된 조회입니다. mission id : ${this.viewingMissionId}`);
              this.toList();
            }
          }
      );
    },
    methods: {
      toList() {
        this.$router.push({name: 'MissionsListReadOnly'});
      }
    },
    computed: {
      viewingMissionId() {
        const paramCampaignId = this.$route.params.missionId;
        return paramCampaignId;
      }
    }
  }
</script>

<style>

</style>
